/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import React, { useCallback, useEffect, useState } from 'react'
import { MinusIconWmo, PlusIconWmo } from '@usap/uicomponents'
import {
  StyledButton,
  StyledContainer,
  StyledInput,
} from './QuantitySelectorWmo.css'
import { useShoppingCartContext } from '../../../../providers/ShoppingCartProvider'

let currentProcess = null
const QuantitySelectorWmo = ({
  selectedValue,
  setSelectedValue,
  disabled,
  maxQuantity,
}) => {
  const { showLoader, shouldShowLoader } = useShoppingCartContext()
  const [quantity, setQuantity] = useState(selectedValue)

  const processUpdateQuantity = useCallback(
    async value => {
      shouldShowLoader(true)
      await setSelectedValue(value)
      shouldShowLoader(false)
      currentProcess = null
    },
    [setSelectedValue, shouldShowLoader],
  )

  const setQuantityUpdate = useCallback(
    value => {
      if (value > maxQuantity || value < 1) {
        return
      }
      if (currentProcess) { clearTimeout(currentProcess) }
      setQuantity(value)
      currentProcess = setTimeout(
        () => {
          processUpdateQuantity(value)
        },
        1000,
      )
    },
    [maxQuantity, processUpdateQuantity, setQuantity],
  )

  const setQuantityDecrementHandler = useCallback(
    async () => {
      await setQuantityUpdate(quantity - 1)
    },
    [setQuantityUpdate, quantity],
  )

  const setQuantityIncrementHandler = useCallback(
    async () => {
      await setQuantityUpdate(quantity + 1)
    },
    [setQuantityUpdate, quantity],
  )

  const setQuantityOnChangeHandler = useCallback(
    event => {
      const { value } = event.target

      if (value.trim() === '') {
        setQuantity(value)
        return
      }

      const numericValue = parseFloat(value) || 0
      if (numericValue < 1) {
        setQuantityUpdate(selectedValue)
        return
      }

      if (numericValue > maxQuantity) {
        setQuantityUpdate(maxQuantity)
        return
      }

      if (numericValue > 0) {
        setQuantityUpdate(value)
      }
    },
    [maxQuantity, selectedValue, setQuantity, setQuantityUpdate],
  )

  const setQuantityOnBlurHandler = useCallback(
    event => {
      const { value } = event.target

      if (value.trim() === '') {
        setQuantityUpdate(selectedValue)
      }
    },
    [selectedValue, setQuantityUpdate],
  )

  useEffect(
    () => {
      if (!currentProcess) {
        setQuantity(selectedValue)
      }
      return () => {
        currentProcess = null
      }
    },
    [selectedValue, setQuantity],
  )

  return (
    <StyledContainer>
      <StyledButton
        onClick={setQuantityDecrementHandler}
        disabled={disabled || showLoader || quantity === 1}
      >
        <MinusIconWmo />
      </StyledButton>
      <StyledInput
        value={quantity}
        disabled={disabled || showLoader}
        onChange={setQuantityOnChangeHandler}
        onBlur={setQuantityOnBlurHandler}
        onClick={e => e.target.select()}
      />
      <StyledButton
        onClick={setQuantityIncrementHandler}
        disabled={disabled || showLoader || quantity === maxQuantity}
      >
        <PlusIconWmo />
      </StyledButton>
    </StyledContainer>
  )
}

export default QuantitySelectorWmo
